import { render, staticRenderFns } from "./intraocularPressure.vue?vue&type=template&id=843ccc72&scoped=true&"
import script from "./intraocularPressure.vue?vue&type=script&lang=js&"
export * from "./intraocularPressure.vue?vue&type=script&lang=js&"
import style0 from "./intraocularPressure.vue?vue&type=style&index=0&id=843ccc72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843ccc72",
  null
  
)

export default component.exports